import { Link, NavLink } from 'react-router-dom';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#F7F3EE] text-[#221E1B] flex flex-col font-sans selection:bg-[#F3E6DC] selection:text-[#B5531E]">
      {/* Slim top bar */}
      <header className="border-b border-[#E6DED5] bg-[#F7F3EE]">
        <div className="max-w-[760px] mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <Link
            to="/"
            className="text-lg font-bold tracking-tight text-[#221E1B] hover:text-[#B5531E] transition-colors"
          >
            Radiatorproblemer.dk
          </Link>
          <nav className="flex items-center gap-3 text-sm text-[#6B625B]">
            <NavLink
              to="/radiator-varmer-ikke"
              className={({ isActive }) =>
                isActive
                  ? 'text-[#B5531E] font-medium underline underline-offset-4'
                  : 'hover:text-[#B5531E] hover:underline underline-offset-4'
              }
            >
              Varmer ikke
            </NavLink>
            <span className="text-[#E6DED5]">·</span>
            <NavLink
              to="/radiator-larmer"
              className={({ isActive }) =>
                isActive
                  ? 'text-[#B5531E] font-medium underline underline-offset-4'
                  : 'hover:text-[#B5531E] hover:underline underline-offset-4'
              }
            >
              Lyde
            </NavLink>
            <span className="text-[#E6DED5]">·</span>
            <NavLink
              to="/udluftning-af-radiator"
              className={({ isActive }) =>
                isActive
                  ? 'text-[#B5531E] font-medium underline underline-offset-4'
                  : 'hover:text-[#B5531E] hover:underline underline-offset-4'
              }
            >
              Udluftning
            </NavLink>
          </nav>
        </div>
      </header>

      {/* Centred reading column */}
      <main className="flex-1 w-full max-w-[760px] mx-auto px-4 sm:px-6 py-10 sm:py-16">
        {children}
      </main>

      {/* Quiet footer */}
      <footer className="border-t border-[#E6DED5] mt-16 bg-[#F7F3EE]">
        <div className="max-w-[760px] mx-auto px-4 sm:px-6 py-8 text-sm text-[#6B625B] flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
          <div>
            Radiatorproblemer er en uafhængig guide
          </div>
          <div className="flex items-center gap-4">
            <Link
              to="/om"
              className="text-[#6B625B] hover:text-[#B5531E] hover:underline underline-offset-4"
            >
              Om siden
            </Link>
            <span className="text-[#E6DED5]">·</span>
            <Link
              to="/ordbog"
              className="text-[#6B625B] hover:text-[#B5531E] hover:underline underline-offset-4"
            >
              Ordbog
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
